import { Directive, HostListener } from "@angular/core";

@Directive({ selector: "[adaptStopPropagation]" })
export class AdaptStopPropagationDirective {
    @HostListener("click", ["$event"])
    public onClick(e: Event) {
        e.stopPropagation();
    }

    @HostListener("pointerdown", ["$event"])
    public onPointerDown(e: Event) {
        e.stopPropagation();
    }
}
